'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const ModalView = require('common/ui/view/modal/index');
const ReadMoreCollectionView = require('framework/ui/view/readmore-collection');
const Idea = require('feedback/domain/entity/idea');
const IdeaListViewTemplate = require('feedback/ui/template/idea/list.hbs');
const IdeaItemViewTemplate = require('feedback/ui/template/idea/item.hbs');
const ReadMoreTemplate = require('feedback/ui/template/idea/readmore.hbs');
const IdeaModal = require('feedback/ui/view/modal/idea');
const CoverView = require('feedback/ui/view/cover');

const IdeaItemView = Mn.View.extend({
    model: Idea,
    tagName: 'tr',
    className: 'idea-item',
    template: IdeaItemViewTemplate,

    templateContext: function() {
        return {
            isPrivate: this.model.isPrivate(),
            url: `/feedback/ideas/${this.model.id}`,
            stateColor: this.model.getState().color,
            commentNum: this.model.getCommentCount()
        }
    }
});


const ReadMoreView = Mn.View.extend({
    tagName: 'tr',
    template: ReadMoreTemplate,
    events: {
        'click': 'more'
    },

    more: function() {
        this.model.more(10);
    }
});

const IdeaCollectionView = ReadMoreCollectionView.extend({
    childView: IdeaItemView,
    tagName: 'tbody',
    readMoreView: ReadMoreView
});

module.exports = Mn.View.extend({
    ui: {
        addIdea: '.add-idea'
    },
    events: {
        'click @ui.addIdea': 'addIdea',
    },
    regions: {
        cover: '#cover',
        publicIdeaList: {
            el: '.public-idea-list',
            replaceElement: true
        },
        myIdeaList: {
            el: '.my-idea-list',
            replaceElement: true
        },
    },

    tagName: 'div',
    className: 'feedback-list row',
    template: IdeaListViewTemplate,

    addIdea: function() {
        const modal = new ModalView({
            title: i18n.t('title.user_request.create'),
            bodyView: new IdeaModal(),
            onChildviewSave: function() {
                this.getOption('bodyView').setting()
                    .then(() => {
                        this.disableButtons();
                        this.hide();
                    })
            }
        });
        modal.show();
    },

    onRender: function() {
        this.showChildView('cover', new CoverView({isIdea: true}));
        this.showChildView('publicIdeaList', new IdeaCollectionView({
            collection: this.getOption("publicCollection")
        }));
        this.showChildView('myIdeaList', new IdeaCollectionView({
            collection: this.getOption("myCollection")
        }));
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/view/idea/list.js